import { createSelector } from "reselect";

import { IMapMarker } from "../Models/IMapMarker";
import { IMapPolygon } from "../Models/IMapPolygon";
import { IRootReducer } from "../Reducers/RootReducer";

export const mapMarkersSelector = createSelector(
    (state: IRootReducer) => state.mapReducer.markers,
    (markers: IMapMarker[]) => markers
);

export const mapPolygonsSelector = createSelector(
    (state: IRootReducer) => state.mapReducer.polygons,
    (polygons: IMapPolygon[]) => polygons
);

export const mapCenterSelector = createSelector(
    (state: IRootReducer) => state.mapReducer.center,
    (center: google.maps.LatLng) => center
);

export const mapZoomSelector = createSelector(
    (state: IRootReducer) => state.mapReducer.zoom,
    (zoom: number) => zoom
);

export const mapLoadingSelector = createSelector(
    (state: IRootReducer) => state.mapReducer.showLoadingOverlay,
    (showLoadingOverlay: boolean) => showLoadingOverlay
);

export const mapSelector = createSelector(
    [
        mapMarkersSelector,
        mapPolygonsSelector,
        mapCenterSelector,
        mapZoomSelector,
    ],
    (
        markers,
        polygons,
        center,
        zoom,
    ) => ({
        markers,
        polygons,
        center,
        zoom,
    })
);
